// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HobV","col":"styles_col__1h2wk","actions":"styles_actions__l2b3S","conflict":"styles_conflict__2wc5d"};